import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CustomerHeader from "../components/CustomerHeader";
import CustomerFooter from "../components/CustomerFooter";
import "../App.css";

function TermsConditions() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        width: "100%",
        overflowX: "hidden",
      }}
    >
      <CustomerHeader />

      {/* Hero Section */}
      <div
        style={{
          background: "linear-gradient(135deg, #2d6da3 0%, #4a90c6 100%)",
          color: "white",
          padding: isMobile ? "30px 16px" : "60px 40px",
          textAlign: "center",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <h1
          style={{
            fontSize: isMobile ? "24px" : "36px",
            marginBottom: "10px",
            fontWeight: "bold",
          }}
        >
          Terms & Conditions
        </h1>
        <p
          style={{
            fontSize: isMobile ? "14px" : "16px",
            opacity: 0.95,
          }}
        >
          Last Updated: February 22, 2026
        </p>
      </div>

      {/* Main Content */}
      <div
        style={{
          flex: 1,
          maxWidth: "900px",
          width: "100%",
          margin: "0 auto",
          padding: isMobile ? "24px 16px" : "60px 40px",
          boxSizing: "border-box",
          overflowX: "hidden",
        }}
      >
        <section style={{ marginBottom: isMobile ? "32px" : "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "22px" : "24px",
              marginBottom: isMobile ? "12px" : "15px",
              color: "#1f2937",
              fontWeight: "700",
              lineHeight: "1.3",
            }}
          >
            1. Acceptance of Terms
          </h2>
          <p
            style={{
              fontSize: isMobile ? "16px" : "16px",
              lineHeight: isMobile ? "1.7" : "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            OGESTYLE is owned and operated by SOFTISS LLC, a Delaware limited
            liability company. Throughout these Terms, "OGESTYLE," "we," "our,"
            and "us" refer to SOFTISS LLC and its OGESTYLE platform.
          </p>
          <p
            style={{
              fontSize: isMobile ? "16px" : "16px",
              lineHeight: isMobile ? "1.7" : "1.8",
              color: "#4b5563",
            }}
          >
            By accessing or using our website, mobile application, and services
            (collectively, the "Services"), you agree to be bound by these Terms
            and Conditions ("Terms"). If you do not agree to these Terms, please
            do not use our Services.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            2. Description of Services
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            OGESTYLE is an online platform that connects customers with beauty
            and wellness professionals, including salons, spas, barbers, hair
            stylists, nail technicians, makeup artists, and independent
            freelance professionals. Our Services include:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginLeft: "20px",
            }}
          >
            <li>Online booking and appointment scheduling</li>
            <li>Service discovery and professional profiles</li>
            <li>Payment processing</li>
            <li>Appointment notifications via SMS and email</li>
            <li>Reviews and ratings</li>
            <li>Business management tools for professionals</li>
          </ul>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            3. User Accounts
          </h2>
          <h3
            style={{
              fontSize: isMobile ? "16px" : "18px",
              marginBottom: "10px",
              color: "#374151",
              fontWeight: "600",
            }}
          >
            3.1 Registration
          </h3>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            To use certain features of our Services, you must create an account.
            You agree to provide accurate, current, and complete information
            during registration and to update such information to keep it
            accurate, current, and complete.
          </p>
          <h3
            style={{
              fontSize: isMobile ? "16px" : "18px",
              marginBottom: "10px",
              color: "#374151",
              fontWeight: "600",
            }}
          >
            3.2 Account Security
          </h3>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            You are responsible for maintaining the confidentiality of your
            account credentials and for all activities that occur under your
            account. You must immediately notify us of any unauthorized use of
            your account.
          </p>
          <h3
            style={{
              fontSize: isMobile ? "16px" : "18px",
              marginBottom: "10px",
              color: "#374151",
              fontWeight: "600",
            }}
          >
            3.3 Age Requirement
          </h3>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            You must be at least 18 years old to create an account and use our
            Services. By creating an account, you represent that you are at
            least 18 years of age.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            4. Bookings and Payments
          </h2>
          <h3
            style={{
              fontSize: isMobile ? "16px" : "18px",
              marginBottom: "10px",
              color: "#374151",
              fontWeight: "600",
            }}
          >
            4.1 Booking Services
          </h3>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            When you book a service through OGESTYLE, you are entering into a
            contract directly with the service professional or business.
            OGESTYLE is a platform that facilitates these transactions but is
            not a party to the contract between you and the service provider.
          </p>
          <h3
            style={{
              fontSize: isMobile ? "16px" : "18px",
              marginBottom: "10px",
              color: "#374151",
              fontWeight: "600",
            }}
          >
            4.2 Payment Processing
          </h3>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            Payments are processed securely through our payment partner, Stripe.
            By making a payment, you authorize us to charge your payment method
            for the total amount of your booking, including any applicable taxes
            and fees.
          </p>
          <h3
            style={{
              fontSize: isMobile ? "16px" : "18px",
              marginBottom: "10px",
              color: "#374151",
              fontWeight: "600",
            }}
          >
            4.3 Platform Fees
          </h3>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            OGESTYLE charges a platform fee on each transaction. This fee is
            included in the total price you pay and is used to maintain and
            improve our Services.
          </p>
          <h3
            style={{
              fontSize: isMobile ? "16px" : "18px",
              marginBottom: "10px",
              color: "#374151",
              fontWeight: "600",
            }}
          >
            4.4 Refunds and Cancellations
          </h3>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            Cancellation and refund policies are set by individual service
            providers. Please review the specific cancellation policy before
            booking. Generally:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginLeft: "20px",
              marginTop: "10px",
            }}
          >
            <li>
              Cancellations made 24+ hours before the appointment may receive a
              full refund
            </li>
            <li>
              Cancellations made less than 24 hours before may be subject to
              cancellation fees
            </li>
            <li>No-shows may result in no refund</li>
            <li>Refunds are processed within 5-10 business days</li>
          </ul>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            5. SMS/Text Message Communications
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            By providing your mobile phone number and opting in, you consent to
            receive automated SMS text messages from OGESTYLE, including:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginLeft: "20px",
              marginBottom: "15px",
            }}
          >
            <li>Booking confirmations</li>
            <li>Appointment reminders</li>
            <li>Cancellation and rescheduling notifications</li>
            <li>Service updates</li>
          </ul>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "10px",
            }}
          >
            <strong>You understand and agree that:</strong>
          </p>
          <ul
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginLeft: "20px",
            }}
          >
            <li>Consent to receive SMS is not a condition of purchase</li>
            <li>Message frequency varies based on your bookings</li>
            <li>Message and data rates may apply</li>
            <li>You may opt-out at any time by texting STOP to our number</li>
            <li>Text HELP for assistance</li>
          </ul>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            6. User Conduct
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            You agree not to:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginLeft: "20px",
            }}
          >
            <li>Violate any laws or regulations</li>
            <li>Infringe on the rights of others</li>
            <li>Submit false or misleading information</li>
            <li>Impersonate another person or entity</li>
            <li>Harass, abuse, or harm others</li>
            <li>Interfere with or disrupt our Services</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Use automated systems to access our Services</li>
            <li>Post inappropriate, offensive, or illegal content</li>
          </ul>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            7. Professional/Business Users
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            If you are a service professional or business using OGESTYLE:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginLeft: "20px",
            }}
          >
            <li>You must have all necessary licenses and insurance</li>
            <li>You are responsible for the quality of services you provide</li>
            <li>You must comply with all applicable laws and regulations</li>
            <li>You agree to honor bookings made through our platform</li>
            <li>
              You must maintain accurate pricing and availability information
            </li>
            <li>
              Payment holds apply (12 hours for service completion verification)
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            8. Intellectual Property
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            All content on OGESTYLE, including text, graphics, logos, images,
            and software, is the property of OGESTYLE or its licensors and is
            protected by copyright, trademark, and other intellectual property
            laws. You may not copy, modify, distribute, or reproduce any content
            without our prior written permission.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            9. Disclaimers and Limitations of Liability
          </h2>
          <h3
            style={{
              fontSize: isMobile ? "16px" : "18px",
              marginBottom: "10px",
              color: "#374151",
              fontWeight: "600",
            }}
          >
            9.1 Service "As Is"
          </h3>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            Our Services are provided "as is" and "as available" without
            warranties of any kind, either express or implied. We do not
            guarantee that our Services will be uninterrupted, secure, or
            error-free.
          </p>
          <h3
            style={{
              fontSize: isMobile ? "16px" : "18px",
              marginBottom: "10px",
              color: "#374151",
              fontWeight: "600",
            }}
          >
            9.2 Third-Party Services
          </h3>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            OGESTYLE is not responsible for the quality, safety, or legality of
            services provided by professionals on our platform. We do not employ
            or supervise service providers and are not liable for their actions
            or omissions.
          </p>
          <h3
            style={{
              fontSize: isMobile ? "16px" : "18px",
              marginBottom: "10px",
              color: "#374151",
              fontWeight: "600",
            }}
          >
            9.3 Limitation of Liability
          </h3>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            To the maximum extent permitted by law, OGESTYLE shall not be liable
            for any indirect, incidental, special, consequential, or punitive
            damages, including loss of profits, data, or goodwill, arising from
            your use of our Services.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            10. Indemnification
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            You agree to indemnify, defend, and hold harmless OGESTYLE, its
            officers, directors, employees, and agents from any claims,
            liabilities, damages, losses, and expenses arising from your use of
            our Services or violation of these Terms.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            11. Dispute Resolution
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            Any disputes arising from these Terms or your use of our Services
            shall be resolved through binding arbitration in accordance with the
            rules of the American Arbitration Association. You agree to waive
            your right to a jury trial or to participate in a class action
            lawsuit.
          </p>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            These Terms shall be governed by the laws of the United States and
            the State of Illinois, without regard to conflict of law principles.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            12. Changes to Terms
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            We reserve the right to modify these Terms at any time. We will
            notify you of material changes by posting the updated Terms on our
            website and updating the "Last Updated" date. Your continued use of
            our Services after changes are posted constitutes your acceptance of
            the revised Terms.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            13. Termination
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            We may suspend or terminate your account and access to our Services
            at any time, with or without notice, for any reason, including
            violation of these Terms. You may also delete your account at any
            time through your account settings.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            14. Contact Information
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            If you have questions about these Terms, please contact us:
          </p>
          <div
            style={{
              background: "#f9fafb",
              padding: "20px",
              borderRadius: "8px",
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            <p style={{ marginBottom: "10px" }}>
              <strong>OGESTYLE</strong>
            </p>
            <p style={{ marginBottom: "10px" }}>Email: support@ogestyle.com</p>
            <p style={{ marginBottom: "10px" }}>Phone: +1-224-487-0006</p>
            <p>
              Website:{" "}
              <a href="https://www.ogestyle.com" style={{ color: "#2d6da3" }}>
                https://www.ogestyle.com
              </a>
            </p>
          </div>
        </section>

        <div
          style={{
            borderTop: "2px solid #e5e7eb",
            paddingTop: "30px",
            textAlign: "center",
          }}
        >
          <Link
            to="/"
            style={{
              display: "inline-block",
              background: "linear-gradient(135deg, #f59e0b 0%, #f97316 100%)",
              color: "white",
              padding: isMobile ? "12px 24px" : "14px 32px",
              borderRadius: "8px",
              textDecoration: "none",
              fontSize: isMobile ? "14px" : "16px",
              fontWeight: "600",
            }}
          >
            Back to Home
          </Link>
        </div>
      </div>

      <CustomerFooter />
    </div>
  );
}

export default TermsConditions;
